
export async function loadScript(src: string): Promise<any> {

    if (document.querySelector(`script[src="${src}"]`)) {
        return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
        const script = document.createElement('script')

        script.async = true
        script.src = src
        script.type = 'text/javascript'
        script.crossOrigin = '*'

        script.onload = resolve
        script.onerror = () => reject(new Error(`Failed to load script from ${src}.`))

        document.body.appendChild(script)
    })
}
